(() => {
 document.querySelectorAll('.pt-story').forEach(story => {
  const body = story.querySelector('.pt-story__body');
  const toc = story.querySelector('.pt-story__toc');
  if (!body || !toc || toc.dataset.ready) return;
  const list = toc.querySelector('ol');
  body.querySelectorAll('h2').forEach((heading, index) => {
   if (!heading.id) heading.id = 'leseabschnitt-' + (index + 1);
   const item = document.createElement('li');
   const link = document.createElement('a');
   link.href = '#' + heading.id;
   link.textContent = heading.textContent.trim();
   item.append(link); list.append(item);
  });
  toc.hidden = !list.children.length;
  toc.dataset.ready = 'true';
  if (matchMedia('(max-width: 989px)').matches) toc.open = false;
  toc.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
   if (matchMedia('(max-width: 989px)').matches) toc.open = false;
  }));
 });
})();